import { render, staticRenderFns } from "./SeccionInfo.vue?vue&type=template&id=64f3759b&scoped=true"
import script from "./SeccionInfo.vue?vue&type=script&lang=js"
export * from "./SeccionInfo.vue?vue&type=script&lang=js"
import style0 from "./SeccionInfo.vue?vue&type=style&index=0&id=64f3759b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3759b",
  null
  
)

export default component.exports